<button
  class="font-toggle"
  [class.font-toggle--enabled]="enabled()"
  (click)="toggle()"
  [attr.aria-pressed]="enabled()"
  aria-label="Toggle dyslexia-friendly font"
  title="Dyslexia-friendly font"
>
  Aa
</button>
